import ImageOptimizer from '@/components/image-optimizer';
import { formatKoreanDate } from '@/lib/date';
import {
  convertRouteFromBoardType,
  slugify,
  storyArticleListPathSegment,
} from '@/lib/utils';
import { ArticleEntity } from '@/services/types/article.type';
import Link from 'next/link';

export default function ArticleCard({
  id,
  title,
  viewDatetime,
  thumbPath,
  subTitle,
  board,
}: ArticleEntity) {
  return (
    <Link
      href={
        convertRouteFromBoardType(board) +
        '/' +
        storyArticleListPathSegment(board.type) +
        '/' +
        slugify(title, id)
      }
      className="block transition"
    >
      <div className="desktop:flex-row desktop:items-center desktop:gap-8 flex flex-col gap-4 bg-white">
        <div className="desktop:gap-10 flex gap-5">
          <div className="desktop:h-[220px] relative aspect-[27/16] h-[106px] flex-shrink-0 overflow-hidden rounded-lg">
            <ImageOptimizer
              src={thumbPath}
              alt={title}
              fill
              className="object-cover"
              // sizes="(max-width: 768px) 100px, 120px"
            />
          </div>
          <div className="desktop:hidden flex flex-col justify-start gap-5">
            <div className="typo-20 text-level-3 desktop:line-clamp-1 mt-2 line-clamp-2 leading-snug font-extrabold">
              {title}
            </div>
            <div className="text-level-5 typo-18 font-semibold">
              {formatKoreanDate(viewDatetime)}
            </div>
          </div>
        </div>
        <div className="text-level-3 typo-18 desktop:line-clamp-2 desktop:hidden line-clamp-3 leading-snug">
          {subTitle}
        </div>
        {/* 웹일때 */}
        <div className="desktop:flex desktop:h-full desktop:grow desktop:flex-col desktop:justify-between hidden">
          <div className="mb-12 h-full">
            <div className="text-level-3 typo-26 desktop:text-level-2 mb-4 leading-snug font-extrabold">
              {title}
            </div>
            <div className="text-level-4 typo-20 desktop:line-clamp-2 desktop:min-h-[55px] line-clamp-3 leading-snug">
              {subTitle}
            </div>
          </div>
          <div className="text-level-5 typo-18 mt-2 font-semibold">
            {formatKoreanDate(viewDatetime)}
          </div>
        </div>
      </div>
    </Link>
  );
}
